// src/pages/TermsPage.js
import React from 'react';
import '../styles/TermsPage.css';

function TermsPage() {
  return (
    <div className="terms-page">
      <div className="terms-container">
        <h1 className="terms-title">Terms of Service</h1>
        <p className="terms-updated">Last Updated: January 2025</p>

        <section className="terms-section">
          <h2>1. Agreement to Terms</h2>
          <p>
            By accessing or using Tact Transport's services, you agree to be bound by these Terms of Service.
            If you do not agree to these terms, please do not use our services. These terms apply to all users
            of our transportation services, including individuals, corporations, and event planners.
          </p>
        </section>

        <section className="terms-section">
          <h2>2. Service Description</h2>
          <p>
            Tact Transport provides luxury ground transportation services including but not limited to:
          </p>
          <ul>
            <li>Executive sedan and SUV transportation</li>
            <li>Airport transfers</li>
            <li>Corporate transportation</li>
            <li>Special event transportation (weddings, proms, sporting events)</li>
            <li>Private chauffeur services</li>
            <li>Armed security transportation upon request</li>
          </ul>
          <p>
            Our service area primarily covers Texas, Louisiana, and Oklahoma. Services outside these areas
            may be available upon request and are subject to additional fees.
          </p>
        </section>

        <section className="terms-section">
          <h2>3. Reservations and Booking</h2>
          <p>
            All reservations are subject to vehicle availability. We recommend booking at least 48 hours
            in advance for standard services and 2-4 weeks in advance for special events.
          </p>
          <p>
            When making a reservation, you must provide accurate information including:
          </p>
          <ul>
            <li>Full name and contact information</li>
            <li>Pickup and drop-off locations</li>
            <li>Date and time of service</li>
            <li>Number of passengers</li>
            <li>Any special requirements or requests</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>4. Pricing and Payment</h2>
          <p>
            Pricing is based on the type of vehicle, duration of service, distance traveled, and any
            additional services requested. A detailed quote will be provided before booking confirmation.
          </p>
          <p>
            Additional charges may apply for:
          </p>
          <ul>
            <li>Wait time exceeding 15 minutes</li>
            <li>Tolls, parking, and airport fees</li>
            <li>After-hours or holiday service</li>
            <li>Additional stops not included in the original booking</li>
            <li>Cleaning fees for excessive mess or damage</li>
          </ul>
          <p>
            We accept major credit cards, corporate accounts, and approved payment methods. A valid
            credit card is required to secure all reservations.
          </p>
        </section>

        <section className="terms-section">
          <h2>5. Cancellation Policy</h2>
          <p>
            Cancellations must be made in accordance with the following policy:
          </p>
          <ul>
            <li><strong>Standard Service:</strong> Cancel at least 24 hours before pickup for a full refund</li>
            <li><strong>Special Events:</strong> Cancel at least 7 days before the event for a full refund</li>
            <li><strong>Late Cancellations:</strong> Cancellations within the notice period may be subject to a fee up to 50% of the booking total</li>
            <li><strong>No-Shows:</strong> Failure to appear at the scheduled pickup time without notice will result in full charge</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>6. Passenger Conduct</h2>
          <p>
            All passengers are expected to conduct themselves in a respectful and lawful manner. The following
            are prohibited in our vehicles:
          </p>
          <ul>
            <li>Smoking or vaping of any kind</li>
            <li>Consumption of illegal substances</li>
            <li>Excessive consumption of alcohol leading to disorderly behavior</li>
            <li>Damage or vandalism to the vehicle</li>
            <li>Harassment of the chauffeur or other passengers</li>
            <li>Any illegal activities</li>
          </ul>
          <p>
            We reserve the right to terminate service immediately and without refund if passengers
            violate these conduct standards.
          </p>
        </section>

        <section className="terms-section">
          <h2>7. Liability and Insurance</h2>
          <p>
            Tact Transport maintains comprehensive commercial insurance coverage for all vehicles and
            passengers. However, our liability is limited to the maximum extent permitted by law.
          </p>
          <p>
            We are not responsible for:
          </p>
          <ul>
            <li>Personal belongings left in vehicles (though we make reasonable efforts to return found items)</li>
            <li>Delays caused by traffic, weather, road closures, or other circumstances beyond our control</li>
            <li>Indirect, incidental, or consequential damages</li>
            <li>Missed flights, meetings, or events due to circumstances outside our control</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>8. Vehicle Condition</h2>
          <p>
            Our vehicles are professionally maintained and cleaned before each service. If you notice
            any pre-existing damage or concerns, please notify your chauffeur immediately. Passengers
            are responsible for any damage to the vehicle occurring during their service period.
          </p>
        </section>

        <section className="terms-section">
          <h2>9. Gratuities</h2>
          <p>
            Gratuities for chauffeurs are not included in quoted rates and are at the discretion of the
            client. While not required, gratuities are appreciated for exceptional service.
          </p>
        </section>

        <section className="terms-section">
          <h2>10. Changes to Terms</h2>
          <p>
            Tact Transport reserves the right to modify these Terms of Service at any time. Changes will
            be effective upon posting to our website. Continued use of our services constitutes acceptance
            of any modified terms.
          </p>
        </section>

        <section className="terms-section">
          <h2>11. Contact Information</h2>
          <p>
            For questions about these Terms of Service, please contact us:
          </p>
          <ul>
            <li>Email: ride@tacttransport.com</li>
            <li>Phone: (214) 984-2522</li>
            <li>Address: PO BOX 190334, Dallas, TX 75219</li>
          </ul>
        </section>
      </div>
    </div>
  );
}

export default TermsPage;
